function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M224.96,256c0,0-15.727,1.994-19.962,4.455c-4.228,2.458-4.893,6.049-1.492,8.012c3.408,1.969,9.607,1.57,13.835-0.886 C221.577,265.12,224.96,256,224.96,256"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M308.486,207.467c-3.401-1.963-9.598-1.567-13.827,0.89c-4.235,2.462-7.619,11.573-7.619,11.573s15.727-1.985,19.962-4.447 C311.23,213.025,311.895,209.434,308.486,207.467"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M212.622,237.968c0,0-13.59-5.035-19.587-5.035c-6.012,0-10.859,2.256-10.851,5.036c0.007,1.19,0.904,2.284,2.397,3.146 c2,1.155,5.07,1.894,8.502,1.894C199.09,243.004,212.622,237.968,212.622,237.968"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M327.416,234.824c-1.999-1.154-5.068-1.893-8.501-1.893c-6.004,0.004-19.538,5.041-19.538,5.041s13.59,5.035,19.594,5.031 c6.005,0.004,10.851-2.252,10.836-5.036C329.803,236.778,328.908,235.686,327.416,234.824"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M217.019,208.362c-4.263-2.461-10.451-2.858-13.838-0.89c-3.387,1.968-2.681,5.55,1.582,8.012 c4.256,2.457,20.005,4.451,20.005,4.451S221.275,210.819,217.019,208.362"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M307.237,260.455c-4.255-2.457-20.006-4.451-20.006-4.451s3.494,9.116,7.75,11.573c4.263,2.461,10.45,2.858,13.837,0.89 C312.205,266.499,311.491,262.912,307.237,260.455"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M256.151,263.096c0,0-8.65,7.856-8.638,11.334c0.011,1.988,1.298,3.764,3.297,4.918c1.492,0.862,3.381,1.376,5.433,1.374 c4.807,0,8.686-2.815,8.666-6.298C264.89,270.95,256.151,263.096,256.151,263.096"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M467.901,240.723c-26.845-21.488-64.13-38.367-107.893-48.868l-78.513-56.894l-9.196,12.691l40.314,29.214 c-5.509-1.405-11.26-2.617-17.244-3.613c-6.26-13.377-17.812-23.18-31.533-25.923V53.023h-15.673v94.308 c-13.722,2.743-25.274,12.546-31.533,25.923c-5.984,0.996-11.735,2.208-17.244,3.613l40.314-29.214l-9.196-12.691L62.4,256.778 l12.141,8.798c-2.197,6.074-3.31,12.284-3.31,18.536c0,0.057,0.003,0.113,0.003,0.17v35.54c0,26.754,19.943,51.458,56.153,69.564 c34.485,17.242,80.16,26.738,128.613,26.738s94.129-9.496,128.613-26.738c36.21-18.106,56.153-42.812,56.153-69.564v-35.57 c0-0.047,0.003-0.093,0.003-0.14c0-6.253-1.113-12.464-3.31-18.536l12.141-8.798l-50.306-36.454 c60.155,23.186,97.032,59.85,97.032,99.159c0,32.124-24.335,62.726-68.52,86.17C382.044,429.932,321.028,443.303,256,443.303 s-126.044-13.372-171.806-37.651c-44.186-23.443-68.52-54.045-68.52-86.17c0-36.119,31.129-70.496,85.403-94.315l-6.298-14.353 C34.545,237.249,0,276.857,0,319.483c0,38.205,27.292,73.724,76.848,100.016c47.985,25.458,111.609,39.478,179.152,39.478 s131.167-14.02,179.152-39.478C484.708,393.206,512,357.686,512,319.483C512,291.05,496.751,263.816,467.901,240.723z M256,162.215 c15.844,0,28.735,15.234,28.735,33.959S271.844,230.134,256,230.134s-28.735-15.234-28.735-33.959S240.156,162.215,256,162.215z  M248.163,245.017v15.825h15.673v-15.825c20.76-4.151,36.571-24.465,36.571-48.843c0-2.067-0.127-4.1-0.348-6.101 c40.169,8.288,68.266,27.592,68.266,47.897c0,12.738-11.249,25.669-30.864,35.475c-21.628,10.815-50.559,16.77-81.462,16.77 s-59.834-5.955-81.462-16.77c-19.616-9.806-30.864-22.737-30.864-35.475c0-20.305,28.096-39.609,68.266-47.897 c-0.22,2.001-0.348,4.034-0.348,6.101C211.592,220.552,227.403,240.867,248.163,245.017z M143.755,271.102 c21.582,20.907,63.294,34.787,112.245,34.787s90.663-13.879,112.245-34.787c-0.995,12.153-12.083,24.341-30.782,33.69 c-21.628,10.815-50.559,16.771-81.463,16.771s-59.835-5.956-81.463-16.771C155.838,295.443,144.75,283.255,143.755,271.102z  M256,337.236c26.595,0,51.05-4.099,71.305-11.193L256,377.713l-71.305-51.67C204.95,333.136,229.405,337.236,256,337.236z  M129.464,227.536c-0.951,3.404-1.464,6.887-1.464,10.434v31.347c0,6.733,1.765,13.208,5.055,19.307L89.11,256.778L129.464,227.536z  M377.603,375.368c-32.35,16.175-75.537,25.084-121.603,25.084s-89.253-8.908-121.603-25.084 c-28.674-14.337-45.285-32.543-47.284-51.638c19.462,22.942,55.758,41.266,102.986,50.495l3.006-15.382 C129.68,346.449,87.037,316.49,86.906,284.26v-0.144h-0.002v-0.004c0-2.94,0.356-5.884,1.058-8.812L256,397.068l24.082-17.45 c42.906-2.859,82.515-13.391,111.747-29.756c13.835-7.745,24.946-16.583,33.062-26.15 C422.897,342.814,406.286,361.027,377.603,375.368z M425.096,284.113v0.004h-0.003v0.116 c-0.115,35.087-50.645,66.487-119.464,76.872l118.41-85.804C424.74,278.229,425.096,281.174,425.096,284.113z M378.944,288.624 c3.29-6.099,5.056-12.572,5.056-19.307V237.97c0-3.548-0.513-7.031-1.464-10.434l40.354,29.243L378.944,288.624z"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 245.551,
  cy: 185.731,
  r: 7.837
});

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var _ref25 = /*#__PURE__*/React.createElement("g", null);

var SvgAppetizer = function SvgAppetizer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256,
    cy: 319.478,
    rx: 248.163,
    ry: 131.657
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBE5DD"
    },
    d: "M256,187.821c-46.029,0-89.119,6.656-126.069,18.241c26.312-5.04,54.686-7.792,84.273-7.792 c137.057,0,248.163,58.945,248.163,131.657c0,48.293-49.021,90.505-122.094,113.416c95.572-18.306,163.89-66.85,163.89-123.865 C504.163,246.766,393.057,187.821,256,187.821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E21220"
    },
    d: "M79.07,284.117v35.706c0,48.857,79.215,88.465,176.93,88.465s176.93-39.607,176.93-88.465v-35.706 H79.07z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FF505D"
    },
    cx: 256,
    cy: 284.118,
    rx: 176.933,
    ry: 88.461
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E21220"
    },
    d: "M370.216,216.56c26.081,15.411,41.816,35.338,41.816,57.108c0,48.857-79.215,88.464-176.93,88.464 c-43.538,0-83.394-7.867-114.216-20.907c32.455,19.177,80.936,31.356,135.114,31.356c97.716,0,176.93-39.607,176.93-88.464 C432.93,257.027,408.571,232.788,370.216,216.56z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "256,387.391 75.755,256.778 256,126.166 436.245,256.778 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3FC378"
    },
    d: "M135.837,237.97v31.347c0,33.182,53.799,60.082,120.163,60.082s120.163-26.9,120.163-60.082V237.97"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B8C4A"
    },
    d: "M344.816,237.97v31.347c0,30.526-45.531,55.733-104.49,59.574c5.13,0.333,10.361,0.508,15.673,0.508 c66.365,0,120.163-26.9,120.163-60.082V237.97H344.816z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#C9EEAE"
    },
    cx: 256,
    cy: 237.975,
    rx: 120.163,
    ry: 60.082
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4E276"
    },
    d: "M329.875,190.583c15.909,10.19,25.39,23.01,25.39,36.938c0,33.182-53.799,60.082-120.163,60.082 c-27.856,0-53.497-4.741-73.875-12.694c21.991,14.085,56.266,23.143,94.773,23.143c66.365,0,120.163-26.9,120.163-60.082 C376.163,218.716,358.047,201.58,329.875,190.583z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#57565C"
    },
    cx: 256,
    cy: 196.18,
    rx: 36.571,
    ry: 41.796
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E3D42"
    },
    d: "M259.473,154.572c7.486,7.653,12.2,18.773,12.2,31.154c0,23.084-16.374,41.796-36.571,41.796 c-1.172,0-2.33-0.069-3.473-0.193c6.469,6.615,15.008,10.642,24.371,10.642c20.198,0,36.571-18.712,36.571-41.796 C292.571,174.43,278.041,156.572,259.473,154.572z"
  }), _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppetizer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appetizer.d5668d3a.svg";
export { ForwardRef as ReactComponent };